"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedLinkModal = void 0;
var react_1 = __importStar(require("react"));
var Modal_1 = require("../../Modals/Modal");
var TextInputs_1 = require("../../TextInputs");
var Paddings_1 = require("../../Paddings");
var Buttons_1 = require("../../Buttons");
var styled_1 = require("../styled");
var utils_1 = require("../utils");
var EmbedLinkModal = function (_a) {
    var _b, _c, _d;
    var id = _a.id, setShowEmbedLinkModal = _a.setShowEmbedLinkModal, value = _a.value, createVideoPreview = _a.createVideoPreview, onChange = _a.onChange, invert = _a.invert;
    var _e = (0, react_1.useState)(value), localValue = _e[0], setLocalValue = _e[1];
    var _f = (0, react_1.useState)(false), isValidURl = _f[0], setIsValidUrl = _f[1];
    var isPreviewableGoogleDriveUrl = (0, utils_1.verifyAndGetGoogleDrivePreviewableUrl)((_b = localValue === null || localValue === void 0 ? void 0 : localValue[0]) === null || _b === void 0 ? void 0 : _b.publicUrl).isPreviewableGoogleDriveUrl;
    return (react_1.default.createElement(Modal_1.Modal, { title: "Add URL Embed", subTitle: "Paste the link of the video you want to share. ", 
        // invert={invert}
        desktopWidth: "50vw", fitToContentHeight: true, onClose: function () {
            setShowEmbedLinkModal(false);
        } },
        react_1.default.createElement("div", { style: { padding: '2rem' } },
            react_1.default.createElement(TextInputs_1.URLInput, { icon: "LinkSimple", onChange: function (k, v) { return setLocalValue(v ? [{ publicUrl: v }] : undefined); }, value: localValue && ((_c = localValue[0]) === null || _c === void 0 ? void 0 : _c.publicUrl), placeholder: "Paste a url here", clearBtn: { text: 'clear' }, displayValidationMsg: false, passValidationErrorToFormValidation: function (status) {
                    if (status === "error") {
                        setIsValidUrl(false);
                    }
                    else {
                        setIsValidUrl(true);
                    }
                } }),
            (localValue && isValidURl) && react_1.default.createElement(Paddings_1.PaddingBottom20, null),
            isValidURl && createVideoPreview({ value: localValue }),
            react_1.default.createElement(styled_1.StyledModalActionButtons, null,
                react_1.default.createElement(Buttons_1.ButtonPrimary, { value: "Embed", disabled: (!(0, utils_1.canPlay)((_d = localValue === null || localValue === void 0 ? void 0 : localValue[0]) === null || _d === void 0 ? void 0 : _d.publicUrl) && !isPreviewableGoogleDriveUrl) || !localValue, 
                    // invert={invert}
                    onClick: function () {
                        onChange(id, localValue);
                        setShowEmbedLinkModal(false);
                    } }),
                react_1.default.createElement(Buttons_1.ButtonGhost, { value: "Cancel", 
                    // invert={invert}
                    onClick: function () {
                        setShowEmbedLinkModal(false);
                    } })))));
};
exports.EmbedLinkModal = EmbedLinkModal;
